import { MascotBubble } from '@tankef/ui';

import type { StepType } from '@reactour/tour';

export const WALLET_TOUR_ID = 'wallet';

export const walletSteps: StepType[] = [
  {
    selector: '[data-tour="wallet-balance"]',
    position: 'bottom',
    content: (
      <MascotBubble emotion="happy" size="sm" direction="right" showPointer={false}>
        Aquí ves tu <strong>saldo disponible</strong> y el retenido por operaciones en proceso.
      </MascotBubble>
    ),
  },
  {
    selector: '[data-tour="wallet-transfer-btn"]',
    position: 'bottom',
    content: (
      <MascotBubble emotion="neutral" size="sm" direction="left" showPointer={false}>
        Desde aquí haces una <strong>transferencia</strong> a cualquier contacto o CLABE bancaria.
      </MascotBubble>
    ),
  },
  {
    selector: '[data-tour="wallet-clabe"]',
    position: 'bottom',
    content: (
      <MascotBubble emotion="hint" size="sm" direction="right" showPointer={false}>
        Esta es tu <strong>CLABE interbancaria</strong>. Compártela para recibir depósitos desde
        cualquier banco.
      </MascotBubble>
    ),
  },
  {
    selector: '[data-tour="wallet-movements"]',
    position: 'top',
    content: (
      <MascotBubble emotion="neutral" size="sm" direction="right" showPointer={false}>
        Todos tus <strong>movimientos</strong> aparecen aquí. Puedes descargar el comprobante de
        cada uno en PDF.
      </MascotBubble>
    ),
  },
  {
    selector: '[data-tour="wallet-movements"]',
    position: 'top',
    content: (
      <MascotBubble emotion="hint" size="sm" direction="right" showPointer={false}>
        Cuando un depósito trae desglose, verás el ícono <strong>ⓘ</strong> junto al monto. Da clic
        para ver el <strong>detalle</strong>: cuánto recibiste, la comisión, el IVA y el neto
        depositado.
      </MascotBubble>
    ),
  },
];
